import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="shrink-0 w-full sm:w-52 h-40 sm:h-32 rounded-md overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 香蕉动漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex flex-col justify-center">
        <div className="flex flex-wrap items-center gap-2 mb-1.5">
          {item.tags.slice(0, 2).map((t) => (
            <span
              key={t}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
        <h3 className="font-bold text-sm md:text-base text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2">{item.summary}</p>
        <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
            {item.date}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
            {item.source}
          </span>
        </div>
      </div>
    </Link>
  );
}